import type { MrtColumnConfig } from './mrtCollectionTypes'

/**
 * A shared group's column offered only as a filter, for a page whose rows don't show that entity's cells. The
 * includes are emptied because a filter-only column never gets a visibility entry, so it would count as visible.
 */
export const asFilterOnlyColumn = <T>(column: MrtColumnConfig<T>): MrtColumnConfig<T> => ({
  ...column,
  includes: [],
  isFilterOnly: true,
})
